
import logger from 'xAppLib/libs/logger'
import statsig from 'xAppLib/providers/statsig'
import intercom from 'xAppLib/providers/intercom'

import user_model from 'models/user_model'
import presence_model from 'models/presence_model'
import messaging_model from 'models/messaging_model'
import device_model from 'models/device_model'
import { getLandingPage } from "@iscr/helpers/getLandingPage";
import orgs_model from 'models/orgs_model'

import merge_multilev_obj from 'xAppLib/helpers/merge_multilev_obj'

import "amp-app.js";
import AppUser from 'models/app_user'
import utm_model from 'models/utm_model'

import inactivity_watch from 'xAppLib/helpers/inactivity_watch'
import localstorage_database from 'xAppLib/providers/localstorage_database'
import API_service from './xAppLib/providers/API_service'

let ran = false

function apply_mode(config) {
	try {
		document.body.classList.add(config.app)
		if (config.theme) {
			document.body.classList.add(config.theme)
		}
		app.settings.icann && document.body.classList.add(app.runtime.mode)
		if (config.css) {
			var head  = document.getElementsByTagName('head')[0];
			for (let i = 0; i < config.css.length; i++) {
				const link  = document.createElement('link');
				link.rel  = 'stylesheet';
				link.type = 'text/css';
				link.href = config.css[i];
				link.media = 'all';
				head.appendChild(link);
			}
		}
		if (config.scripts) {
			for (let i = 0; i < config.scripts.length; i++) {
				document.body.appendChild(document.createElement('script')).src = config.scripts[i];
			}
		}
	} catch (e) {
		console.log(e);
	} 
	
}

export const update_runtime = async () =>  {
	await load_runtime_org()

	app.runtime?.start_page && app.history.push(app.runtime.start_page);
}

export const load_runtime_org = async () => {
	let org_data = await orgs_model.get_record(null, null, {act:'getusrorg', oid:app.runtime.partn_oid || app.runtime.partn_pharm_oid || 'app'});
	if (!org_data || (org_data && org_data.res != 'ok')) {
		org_data = await orgs_model.get_record(null, null, {act:'getusrorg', oid:app.runtime.partn_oid || app.runtime.partn_pharm_oid || 'app'});
	}
	app.runtime.org = org_data?.res == 'ok' && org_data || {}
	app.runtime.uip = org_data?.res == 'ok' && org_data.uip || null
}

export const prep_env = async (call_after) => {
	
	if (ran) {
		return
	}
	ran = true
	
	apply_mode(app.runtime)

	localstorage_database.init('device_conf')

	app.timing = {init_start: Date.now()};
	
	// TODO remove extra step in code and use ACL
	app.dev_env_local = app.settings.dev_env_local
	app.dev_env_remote = app.settings.dev_env_remote
	app.dev_env = app.settings.dev_env
	app.test_env = app.settings.test_env
	app.app_data.ws_conf = __RUN_MODE__=='loc' && merge_multilev_obj(require('conf/ws_conf.json'), require('conf/loc_conf.json'))
							|| require('conf/ws_conf.json');
	if (__LOCAL_PROD__) {
		app.app_data.ws_conf.loc.API__SCRIPT_BASE__url = app.app_data.ws_conf.loc.API__SCRIPT_BASE__url.replace('8080','8081')
	}
	logger.init();

	statsig.init({}).catch(e => console.warn('Statsig init failed', e));

	app.settings.guest_name = 'Guest'+Math.round(Math.random()*1000)

	app.user = new AppUser()

	const user = user_model.check_user()

	const dvc = (new Promise(resolve => new device_model().init(resolve,user))); 

	const rnt =  update_runtime()

	await Promise.all([user,dvc,rnt])

	// TODO INST-7295 
	// An api.instantcosmetics.com.au subdomain will need to be setup on prod for the cross-domain cookies to work
	// and needs to flow through to the app (in ws_conf.json)
	// eg:
	// "COSM_API__SCRIPT_BASE__url": "https://api.instantcosmetics.com.au/",
	if (app.settings.icosm && !app.user.uid) {
		try {
			// If there's a session cookie, this API returns a token to login the user
			// If not, it returns a 401 and we ignore it since there's no way to know if there's a cookie or not, so it's always sent on load for cosm if the user isn't logged in
			const res = await API_service.api_promise('auth/client-token', {}, { credentials: true });
			if (res?.res == 'ok' && res?.token) {
				await user_model.signInWithCustomToken(res.token);
				await user_model.check_user();
			}
		} catch (e) {
			// Ignore 401s since that'll happen when there's no cookie sent. We can't tell if there's a cookie or not, so it's always sent on load
			if (!(e instanceof Response) || e.status !== 401) {
				console.error(e);
			}
		}
	}


	app.dev_env && console.log('app.runtime', app.runtime);

	// app.runtime?.start_page && app.history.push(app.runtime.start_page);

	if (window.location.pathname === "/") {
		const landing_page = getLandingPage();
		if (landing_page) {
			app.history.push(landing_page);
		}
	}

	// console.log('loaded site configuration and data', app.app_data.ws_conf.site.year)

	call_after();

	app.timing.init_fin = Date.now();
	app.timing.ld_tm = app.timing.init_start - window.time_ld_start;
	app.timing.init_tm = app.timing.init_fin - app.timing.init_start;
	app.runtime.perf = {ld_tm: app.timing.ld_tm/1000, init_tm: app.timing.init_tm/1000};

	logger.site_start();

	messaging_model.init();

	utm_model.init();

	await (new Promise(resolve => setTimeout(resolve, 3*1000))); 

	await presence_model.connect();

	inactivity_watch(2*60, _=>app.trigger( app.events.IDLE_START ), _=>app.trigger( app.events.IDLE_END ), _=>app.trigger( app.events.IDLE_RESET ))

	app.trigger(app.events.SITE_READY);

	// Never boot the messenger on a booth touchscreen - a support chat is a way off a locked kiosk and out to
	// arbitrary links and file uploads, so it is shut down rather than merely hidden.
	if (app.settings.is_booth) {
		window.Intercom('shutdown');
	} else {
		!app.user?.user_in && window.Intercom('shutdown');
		intercom.boot({ app_id: 'ksq5hplh', hide_default_launcher: !app.site_status?.use_intercom || app.settings.is_cbls || app.settings.is_cmg, });
	}
}

